import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = { villagePartId: number };
type TOutput = { description: string };

export default class VillagePartDescriptionApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ villagePartId }: TInput): string {
    return `/fe-api/village-part/description/${villagePartId}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return { description: data.description };
  }
}
